import { useState, useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import CedantSimulator from "@/pages/CedantSimulator";
import CedantResult from "@/pages/CedantResult";
import RepreneurQualification from "@/pages/RepreneurQualification";
import RepreneurResult from "@/pages/RepreneurResult";
import Opportunites from "@/pages/Opportunites";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Methodologie from "@/pages/Methodologie";
import Header from "@/components/Header"; // Importez votre header
import SignUp from "./pages/SignUp";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminForgotPassword from "@/pages/AdminForgotPassword";
import AdminResetPassword from "@/pages/AdminResetPassword";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Header /> {/* Header affiché sur toutes les pages */}
        <Routes>
          <Route path="/final-signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profile" element={<Profile />} />

          <Route path="/" element={<LandingPage />} />
          <Route path="/cedant" element={<CedantSimulator />} />
          <Route path="/cedant/resultat" element={<CedantResult />} />
          <Route path="/repreneur" element={<RepreneurQualification />} />
          <Route path="/repreneur/resultat" element={<RepreneurResult />} />
          <Route path="/opportunites" element={<Opportunites />} />
          <Route path="/methodologie" element={<Methodologie />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
